import { TripDepartureAtFilter } from './TripDepartureAtFilter';
import { TripPanelFilter } from './TripPanelFilter';
import { TripStateFilter } from './TripStateFilter';
import { TripToAssignFilter } from './TripToAssignFilter';
import { useTripsFilters } from '../../hooks/useTripsFilters';
import { t } from '../../services/translation/translation';

type Props = {
  isAssignable: boolean;
};

export const TripsFilters = ({ isAssignable }: Props) => {
  const { handleChange, handleStrictChange, handleReset } = useTripsFilters();
  return (
    <div className="flex items-center gap-2 mb-2">
      <p className="text-sm font-normal text-gray-500 dark:text-gray-400">{t('common.filters')}</p>

      <TripPanelFilter onChange={handleChange} />
      <TripStateFilter onChange={handleChange} />
      {isAssignable ? <TripToAssignFilter onChange={handleStrictChange} /> : null}
      <TripDepartureAtFilter onChange={handleChange} />

      <button
        type="button"
        className="font-medium text-blue-600 dark:text-blue-500 hover:underline text-sm"
        onClick={handleReset}
      >
        {t('common.reset')}
      </button>
    </div>
  );
};
